import React, {Component} from 'react';
import {Input, Table} from 'reactstrap';
import Switch from 'react-bootstrap-switch';
import 'react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css'
import {SUPER_ADMIN} from '../../helpers/constants';
import './attributesList.css';
import {connect} from "react-redux";
import {I18n} from '../../I18n/components/attributesList';
import AttributesListButtons from "./AttributesListButtons";
import swal from 'sweetalert'

class AttributesList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attributes: {}
        }
    }

    onSaveAttributes = () => {
        const {attributes} = this.state;
        const sendAttributes = Object.keys(attributes).reduce((res, item) => {
            res.push({id: +item, value: attributes[item]});
            return res;
        }, []);
        if (sendAttributes.length > 0) {
            this.props.updateAttributesList(sendAttributes);
        } else {
            this.props.updateAttributesList(null)
        }
        this.onResetChanges();
    };

    onInputChange = editingCapability => {
        return event => {
            if ((!this.props.isAttributesChangingAllowed || !editingCapability)
                && this.props.authority !== SUPER_ADMIN) {
                swal(
                    I18n[this.props.lang].contactUsToAccessThis,
                    "",
                    "error")
                return
            }

            const {attributes} = this.state;
            let id,
                value = null;
            if (event.props) {
                id = event.props.id;
                value = !event.props.value;
            }
            if (event.target) {
                id = event.target.id;
                value = event.target.value;
            }
            if (id !== null && value !== null) {
                attributes[id] = value;
                this.setState({
                    attributes
                }, () => {
                    console.log(this.state)
                });
            }
        }
    };

    setDefaultValue = attr => {
        return attr.value
    };

    onResetChanges = () => {
        this.setState({
            attributes: {}
        }, () =>{
            if (this.props.close) {
                this.props.close();
            }
            if (this.props.toggleApkModal) {
                this.props.toggleApkModal();
            }
        });
    };

    showInputs = attr => {
        if (attr.attribute.permittedValues && attr.attribute.permittedValues.length > 1) {
            return (
                <Input
                    type="select"
                    name={attr.attribute.name}
                    id={attr.id}
                    disabled={this.props.authority === SUPER_ADMIN ||
                    attr.attribute.editableByCompany ? false : true}
                    onChange={this.onInputChange(attr.attribute.editableByCompany)}
                    value={this.state.attributes[attr.id] ?
                        this.state.attributes[attr.id] : this.setDefaultValue(attr)}>
                    <option value=""></option>
                    {
                        attr.attribute.permittedValues ? (
                            attr.attribute.permittedValues.map((elem, i) => {
                                return (
                                    <option value={elem} key={i}>{elem}</option>
                                )
                            })
                        ) : (
                            <option></option>
                        )
                    }
                </Input>
            )
        } else if (attr.attribute.valueType === 'BOOLEAN') {
            return (
                <Switch
                    id={attr.id}
                    name={attr.attribute.name}
                    onText={I18n[this.props.lang].yes}
                    offText={I18n[this.props.lang].no}
                    value={this.state.attributes.hasOwnProperty([attr.id]) ?
                            this.state.attributes[attr.id] : (this.setDefaultValue(attr) == "true")}
                    onChange={this.onInputChange(attr.attribute.editableByCompany)}
                />
            )
            // <Input
            //     type="select"
            //     name={attr.attribute.name}
            //     id={attr.id}
            //     disabled={this.props.authority === SUPER_ADMIN ||
            //         attr.attribute.editableByCompany ? false : true}
            //     onChange={this.onInputChange}
            //     value={this.state.attributes[attr.id] ?
            //         this.state.attributes[attr.id] : this.setDefaultValue(attr)}>
            //     <option value="true">true</option>
            //     <option value="false">false</option>
            // </Input>
        } else {
            return (
                <Input
                    type="text"
                    disabled={this.props.authority === SUPER_ADMIN
                    || attr.attribute.editableByCompany ? false : true}
                    readOnly={attr.attribute.xpathMapping.length > 1 ? true : false}
                    name={attr.attribute.name}
                    id={attr.id}
                    onChange={this.onInputChange(attr.attribute.editableByCompany)}
                    defaultValue={this.state.attributes[attr.id] ?
                        this.state.attributes[attr.id] : this.setDefaultValue(attr)}
                />
            )
        }
    };

    renderAppAttributes = attributes => {
        return attributes.filter(attr => attr.attribute !== null).map((attr, index) => { ///fix null value of attribute
            return this.props.isTypeShown ? (
                <tr key={attr.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{attr.attribute.name}</td>
                    <td>{attr.attribute.valueType}</td>
                    <td>
                        {this.showInputs(attr)}
                    </td>
                </tr>
            ) : (
                <tr key={attr.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{attr.attribute.name}</td>
                    <td>
                        {this.showInputs(attr)}
                    </td>
                </tr>
            )
        })
    };

    render() {
        const { attributes, lang, authority, onDeleteApp, closeModal, editDisable } = this.props;
        const isEditable = attributes.filter(elem => elem.attribute &&
            elem.attribute.editableByCompany === true).length > 0;
        return (
            <div className="attributes-list">
                <Table size="sm" className="attributes-list__table">
                    <thead>
                        {
                            this.props.isTypeShown ? (
                                <tr>
                                    <th>#</th>
                                    <th>{I18n[lang].name}</th>
                                    <th>{I18n[lang].type}</th>
                                    <th>{I18n[lang].value}</th>
                                </tr>
                            ) : (
                                <tr>
                                    <th>#</th>
                                    <th>{I18n[lang].name}</th>
                                    <th>{I18n[lang].value}</th>
                                </tr>
                            )
                        }
                    </thead>
                    <tbody>
                    {this.renderAppAttributes(attributes)}
                    </tbody>
                </Table>
                {this.props.children ? this.props.children : undefined}
                <AttributesListButtons
                    lang={lang}
                    isEditable={isEditable}
                    authority={authority}
                    onDeleteApp={this.props.authority === SUPER_ADMIN ? onDeleteApp : false}
                    closeModal={closeModal}
                    editDisable={editDisable}
                    onResetChanges={ this.onResetChanges}
                    onSaveAttributes={this.onSaveAttributes}
                />
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
    };
};

const mapStateToProps = state => ({
    lang: state.languageReducer.lang

});

export default connect(mapStateToProps, mapDispatchToProps)(AttributesList)



// WEBPACK FOOTER //
// ./src/components/AttributesList/AttributesList.js